import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import BlogLayout from './BlogLayout';
import { BLOG_POSTS } from '../data/blogPosts';

function BlogListPage() {
  return (
    <BlogLayout>
      <section className="blog-hero">
        <div className="t5-wrap">
          <span className="t5-kicker">Resource desk</span>
          <h1>Family Tree Maker guides &amp; articles</h1>
          <p>
            Nine practical reads on backup, migration, sync, and upgrades—written from real support tickets. Start here,
            then open live chat if you want step-by-step help on your tree.
          </p>
          <Link to="/#blog" className="blog-back-link">
            ← Back to homepage resources
          </Link>
        </div>
      </section>

      <section className="t5-section">
        <div className="t5-wrap">
          <div className="t5-blog-grid t5-blog-grid--all">
            {BLOG_POSTS.map((post) => (
              <article key={post.slug} className="t5-blog-card">
                <div className="t5-blog-card__body">
                  <span className="t5-blog-card__topic">{post.topic}</span>
                  <time dateTime={post.date}>{post.date}</time>
                  <h2>
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h2>
                  <p>{post.excerpt}</p>
                  <div className="t5-blog-card__meta">
                    <span>{post.readTime}</span>
                    <Link to={`/blog/${post.slug}`} className="t5-blog-card__read">
                      Read article
                      <ArrowRight size={16} aria-hidden />
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </BlogLayout>
  );
}

export default BlogListPage;
